import { ChatsCircleIcon } from '@/shared';
import { type PersonalManagerV1 } from '@/shared/api';

import { type UserNavLink } from '.';

export const getSupportNavigation = (
	personalManager?: PersonalManagerV1,
): UserNavLink[] => [
	// {
	// 	name: 'Телеграм чат',
	// 	hint: 'Общение',
	// 	href: 'https://t.me/+7EFlpkkIRH4yNDNi',
	// 	icon: HeadsetIcon,
	// 	extended: true,
	// },
	{
		name: 'Пиши по любым вопросам',
		hint: personalManager?.telegramUsername ? (
			<>
				Напиши свой вопрос:{' '}
				<a
					href={`https://t.me/${personalManager.telegramUsername}`}
					target="_blank"
					className="text-accent hover:underline"
				>
					@{personalManager.telegramUsername}
				</a>{' '}
				- комьюнити менеджер.
				<span className="block">
					Ответит с 9:00 до 19:00 по МСК в будние дни.
				</span>
			</>
		) : (
			<>
				Напиши свой вопрос:{' '}
				<a
					href="https://t.me/Karina_algocode_io"
					target="_blank"
					className="text-accent hover:underline"
				>
					@Karina_algocode_io
				</a>{' '}
				(Карина) - комьюнити менеджер.
				<span className="block">
					Ответит с 9:00 до 19:00 по МСК в будние дни.
				</span>
			</>
		),
		href: personalManager?.telegramUsername
			? `https://t.me/${personalManager.telegramUsername}`
			: 'https://t.me/Karina_algocode_io',
		icon: ChatsCircleIcon,
		extended: true,
	},
	{
		name: 'В экстренных случаях',
		hint: (
			<>
				Если случилась несправедливость со стороны сотрудников algocode.io ты
				всегда можешь написать основателю сообщества:{' '}
				<a
					href="https://t.me/fatinmaks"
					target="_blank"
					className="text-accent hover:underline"
				>
					@fatinmaks
				</a>{' '}
				и я помогу
			</>
		),
		href: 'https://t.me/fatinmaks',
		icon: ChatsCircleIcon,
		extended: true,
	},
];

export const userNavigation: UserNavLink[] = [
	{ name: 'Финансы', href: '/profile/subscriptions' },
];
